import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {JOBPOSITION} from "../../../Config/ApiUrl";
import {axiosPatch, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import {DepartmentFilterMixin,} from "../FilterMixin"

export default {
    mixins: [DatatableHelperMixin, DepartmentFilterMixin],
    data() {
        return {
            options: {
                name: this.$t('job_position.title'),
                url: JOBPOSITION,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'text',
                        key: 'title',
                        isVisible: true,
                    },
                    {
                        title: this.$t('department'),
                        type: 'custom-html',
                        key: 'department',
                        isVisible: true,
                        modifier: (department) => {
                            return department ? department.name ? department.name : '-' : '-';
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('department'),
                        type: "multi-select-filter",
                        key: "departments",
                        option: [],
                        listValueField: 'name',
                        permission: !!this.$can('view_departments')
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('view_details'),
                        key: "view_details",
                        url: JOBPOSITION,
                    },
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-job-position-modal',
                        modalId: 'job-position-modal',
                        url: JOBPOSITION,
                        name: 'edit',
                        modifier: row => this.$can('update_job_position')
                    },
                    {
                        title: this.$t('jobPosition.delete'),
                        key: 'delete_job_position',
                        url: JOBPOSITION,
                        modifier: row => row.id
                    }
                ],
            }
        }
    }
}
